import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { SalesforceField } from '../../model/salesforce-form.model';

@Component({
  selector: 'app-salesforce-multipicklist-field',
  templateUrl: './salesforce-multipicklist-field.component.html',
  styleUrls: ['./salesforce-multipicklist-field.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class SalesforceMultipicklistFieldComponent implements OnInit {
  @Input() field: SalesforceField;
  @Input() form: UntypedFormGroup;
  @Input() errorText: string;

  public selectedValue: string[] = [];

  ngOnInit() {
    if (this.field.value) {
      this.selectedValue = (<string> this.field.value).split(';');
      this._setFieldValue();
    }
  }

  get isValid() {
    return this.form.controls[this.field.name].valid;
  }

  public onSelectionChange(): void {
    this._setFieldValue();
  }

  private _setFieldValue(): void {
    this.form.controls[this.field.name].setValue(this.selectedValue);
  }
}
